import { useApiGet } from '../../api/Api.hooks';

export interface StudyParticipantDownloadableFormDto {
  name: string;
  formTemplateId?: number;
  formTemplateVersion?: number;
  entityDataId?: number;
  documentId?: number;
}

export function useGetStudyParticipantDownloadableForms(
  studyParticipantId: number
) {
  const { data, isLoading, error, get } = useApiGet<
    StudyParticipantDownloadableFormDto[]
  >(`study-participants/${studyParticipantId}/downloadable-forms`);

  return {
    downloadableForms: data,
    loadingDownloadableForms: isLoading,
    loadingDownloadableFormsError: error,
    getDownloadableForms: get
  };
}
